export function getQueryParamsFromObject<T extends Record<string, unknown>>(input: T) {
  return `${Object.keys(input).map((key) => `${key}=${input[key as keyof T]}`)}`;
}
